import {  useQuery } from "@tanstack/react-query";
import { client } from "src/utils/axios-client";
import { useContext } from "react";
import { AIOption, AIOptionGroup, AIOptionGroupWithGoalsAndTones } from "../AI-Types";

export const apiUri = '/api/ai/options';

export const useGetAITones = () => useQuery<AIOption[]>({
    queryKey: ['ai-tones-list'],
    queryFn: () => client.get(`${apiUri}/tones`, { params: {} }).then((res) => res.data),
    placeholderData: []
});

export const useGetAIActions2 = (actionType: string) => {    
    const useGetAIActions = useQuery<AIOptionGroupWithGoalsAndTones[]>({
        queryKey: ['ai-actions-list'],
        queryFn: () => client.get(`${apiUri}/actions`, { params: {} }).then((res) => res.data),
        onSuccess: (data: AIOptionGroupWithGoalsAndTones[]) => {                      
            if (data.length > 0) {
                const actionGroup = data[0];
                const action = actionGroup.options.filter(p => p.type === actionType);

                //setChatRequest({
                //    ...chatRequest,
                //    actionGroup,
                //    actions: [...action]
                //})
            }
        },
        placeholderData: []
    });

    return useGetAIActions;

}

export const useGetAIActions = () => useQuery<AIOptionGroupWithGoalsAndTones[]>({
    queryKey: ['ai-actions-list'],
    queryFn: () => client.get(`${apiUri}/actions`, { params: {} }).then((res) => res.data),
    //onSuccess: (data: AIOptionGroupWithGoalsAndTones[]) => {
    //    const { chatRequest, setChatRequest } = useContext(ChatContext)
    //},
    placeholderData: []
});

export const useGetAIRoles = () => useQuery<AIOptionGroup[]>({
    queryKey: ['ai-roles-list'],
    queryFn: () => client.get(`${apiUri}/roles`, { params: {} }).then((res) => res.data),
    placeholderData: []
});

export const useGetAIContentTypes2 = (contentType: string) => {
    /*const { chatRequest, setChatRequest } = useContext(ChatContext);*/
    const useGetAIContentTypes = useQuery<AIOptionGroup[]>({
        queryKey: ['ai-content-types-list'],
        queryFn: () => client.get(`${apiUri}/content-types`, { params: {} }).then((res) => res.data),
        onSuccess: (data: AIOptionGroup[]) => {            
            if (data.length > 0) {
                const group = data[0];
                const item = group.options.find(p => p.type === contentType);
                //debugger;
                //setChatRequest({
                //    ...chatRequest,
                //    contentType: item                    
                //})
            }
        },
        placeholderData: []
    });

    return useGetAIContentTypes;

}

export const useGetAIContentTypes = () => useQuery<AIOptionGroup[]>({
    queryKey: ['ai-content-types-list'],
    queryFn: () => client.get(`${apiUri}/content-types`, { params: {} }).then((res) => res.data),
    placeholderData: []
});

export const useGetAIGoals = () => useQuery<AIOption[]>({
    queryKey: ['ai-goals-list'],
    queryFn: () => client.get(`${apiUri}/goals`, { params: {} }).then((res) => res.data),
    placeholderData: []
});